import { useEffect, useRef, useState } from 'react'
import QrScanner from 'qr-scanner'

export interface MaCa { session_id: number; site_id: number; code: string }

export function docMaCa(raw: string): MaCa {
  if (raw.length > 1000) throw new Error('Mã QR không hợp lệ')
  const v = JSON.parse(raw) as MaCa
  if (!Number.isSafeInteger(v.session_id) || v.session_id <= 0
      || !Number.isSafeInteger(v.site_id) || v.site_id <= 0
      || typeof v.code !== 'string' || !/^\d{6}$/.test(v.code)) {
    throw new Error('Đây không phải mã ca công trình')
  }
  return { session_id: v.session_id, site_id: v.site_id, code: v.code }
}

export default function QuetQR({ onXong, onHuy }: { onXong: (ma: MaCa) => void; onHuy: () => void }) {
  const video = useRef<HTMLVideoElement>(null)
  const onResult = useRef(onXong)
  onResult.current = onXong
  const [loi, setLoi] = useState('')
  useEffect(() => {
    if (!video.current) return
    let done = false
    const scanner = new QrScanner(video.current, result => {
      if (done) return
      try {
        const ma = docMaCa(result.data)
        done = true
        scanner.stop()
        onResult.current(ma)
      } catch { setLoi('QR không phải mã ca. Hãy quét mã trên máy tổ trưởng.') }
    }, { preferredCamera: 'environment', returnDetailedScanResult: true })
    void scanner.start().catch(() => { if (!done) setLoi('Không mở được camera. Cấp quyền camera hoặc nhập mã 6 số.') })
    return () => { done = true; scanner.destroy() }
  }, [])
  return <section className="khoi">
    <h2>Quét mã ca tổ trưởng</h2>
    <video ref={video} style={{ width: '100%', maxHeight: 320 }} muted playsInline />
    {loi && <p role="alert">{loi}</p>}
    <button type="button" className="lien-ket-phu" onClick={onHuy}>Đóng camera</button>
  </section>
}
